import { render, staticRenderFns } from "./FormSendCode.vue?vue&type=template&id=e8714b42"
import script from "./FormSendCode.vue?vue&type=script&lang=js"
export * from "./FormSendCode.vue?vue&type=script&lang=js"
import style0 from "./FormSendCode.vue?vue&type=style&index=0&id=e8714b42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports